import {
    EnvironmentProviders,
    inject,
    makeEnvironmentProviders,
    provideAppInitializer
} from '@angular/core';
import { take } from 'rxjs';
import { FeatureFlagService } from './feature-flag.service';
import { FEATURE_FLAGS_CONFIG, FeatureFlagsConfig } from './feature-flags.types';

/**
 * Provides feature flags configuration and initializes the service
 * @param configs Configuration for feature flags
 * @returns Environment providers
 */
export function provideFeatureFlags(configs: FeatureFlagsConfig): EnvironmentProviders {
    return makeEnvironmentProviders([
        { provide: FEATURE_FLAGS_CONFIG, useValue: configs },
        provideAppInitializer(() => {
            const featureFlagsService = inject(FeatureFlagService);

            // Auto-start the service unless lazyStart is true
            if (configs.enabled && !configs.lazyStart) {
                featureFlagsService.start();
            }

            // Wait for initialization
            return featureFlagsService.initialized$.pipe(take(1));
        })
    ]);
}
